export const config = {
  API_URL: "//localhost:8090/",
  PROTOCOL: "http:",
  API_CLIENT_ID: "safebuilt_local",
  API_CLIENT_SECRET: "safebuilt_local",
  INTEGRATION_USER_EMAIL: "cc_reviewer@safebuilt.com",
  INTEGRATION_USER_PASSWORD: "cc_safecv",
  WS_URL: null,
  FULL_STORY_ENABLED: false,
  PDFTRON_VISIBILITY: true,
  FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED: true,
  FEATURE_SHARE_VISIBILITY_ENABLED: false,
  FEATURE_REVIEWER_SSO_ENABLED: false,
  FEATURE_GT_UPLOAD_ENABLED: true,
  FEATURE_FTS_ENABLED_FROM: 999,
  FEATURE_HIGHLIGHT_ENABLED: true,
};
